"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const constants_1 = require("@/constants");
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const notistack_1 = require("notistack");
function Support() {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const [name, setName] = (0, react_1.useState)("");
    const [email, setEmail] = (0, react_1.useState)("");
    const [principal, setPrincipal] = (0, react_1.useState)("");
    const [details, setDetails] = (0, react_1.useState)("");
    const [errors, setErrors] = (0, react_1.useState)({
        name: "",
        email: "",
        principal: "",
        details: "",
    });
    const handleSubmit = async () => {
        setIsLoading(true);
        setErrors({
            name: "",
            email: "",
            principal: "",
            details: "",
        });
        if (!name || !email || !principal || !details) {
            setErrors({
                name: name || "Enter your name",
                email: email || "Enter your email",
                principal: principal || "Enter your principal",
                details: details || "Specify your ticket details",
            });
        }
        else {
            const balanceListResult = await fetch(`${constants_1.REST_API_BASE_URL}/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name,
                    email,
                    message: `${details} User Principal:${principal}`
                }),
            });
            if (balanceListResult.status === 200) {
                setIsSuccess(true);
                enqueueSnackbar("Ticket submited sucessfully", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
            else {
                enqueueSnackbar("Service issue appeared. Please try again later.", {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HelmetTitle_1.default, { title: 'Create Support ticket', description: 'All the information you need to know about ORIGYN, tokenomics and other important things' }),
        react_1.default.createElement(origyn_art_ui_1.Container, { size: "md", padding: '20px' }, isSuccess ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h2", null, "Thank you for contacting ORIGYN Support team"),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", null, "We will analyze your request and get back to you as soon as possible."),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("h6", null,
                    "Best,",
                    react_1.default.createElement("br", null),
                    " ORIGYN technical support team"),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null)))) : (react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement("h2", null, "Create a support ticket"),
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Name", value: name, onChange: (e) => setName(e.target.value), placeholder: "Enter your name", error: errors.name }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Contact Email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "Specify the email we can use to reach back to you", error: errors.email }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Wallet Principal", value: principal, onChange: (e) => setPrincipal(e.target.value), error: errors.principal, placeholder: "Specify your principal" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement("p", { style: { fontWeight: 600 } }, "Description"),
            react_1.default.createElement(origyn_art_ui_1.TextArea, { name: "Subject", value: details, onChange: (e) => setDetails(e.target.value), placeholder: "Describe your issue in details", style: { borderColor: "#E3E3E3" } }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(origyn_art_ui_1.Flex, null,
                react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "filled", onClick: handleSubmit, disabled: isLoading },
                    "Submit",
                    isLoading && "ing...")),
            react_1.default.createElement("br", null))))));
}
exports.default = Support;
